import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DegradationPathwayDialogResult } from './degradation-pathway-dialog-content.interface';

@Component({
  selector: 'degradation-pathway-dialog-content-component',
  templateUrl: './degradation-pathway-dialog-content.component.html',
})
export class DegradationPathwayDialogContentComponent implements OnInit {

  @Input() params: any;

  @Output() onBlurEmmit = new EventEmitter<DegradationPathwayDialogResult>();

  public url?: string;

  public ngOnInit(): void {
    this.url = this.params?.data?.pathwayUrl
  }

  public onBlur(): void {
    this.onBlurEmmit.emit({url:this.url, hasChanges: true});
  }

}
